import { registerComponent } from '../lib/ComponentHelpers';
import RangedAttack from './RangedAttack';
import type { DisplayInfo } from '../types/Components';
import HexOffsetSet from '../grid/HexOffsetSet';

/**
 * An ability that lets an actor throw a rock at a target at a fixed distance of 2.
 */
class ThrowRock extends RangedAttack {
  constructor(data: { damage?: number, priority?: number } = {}) {
    super({
      damage: data.damage ?? 100,
      priority: data.priority ?? 25,
      rangePattern: HexOffsetSet.construct(HexOffsetSet.arc(2)),
    });
  }

  getDisplayInfo(): DisplayInfo {
    return { icon: 'game-icons:stone-pile', label: 'Throw Rock', description: 'Throws a rock at range.' };
  }

  static getTestInstances(): ThrowRock[] {
    return [
      new ThrowRock({ damage: 100, priority: 25 }),
      new ThrowRock({ damage: 75, priority: 30 }),
      new ThrowRock({ damage: 50, priority: 20 }),
    ];
  }
}

export default registerComponent(ThrowRock);
